import { type FC } from 'react';

import Table from '@/components/UI/Table';
import type { TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';
import { renderMetadataValue } from '@/helpers';

import type { SuccessfulOverviewSection } from '../../OverviewAccordion.model';
import overviewTableStyles from '../OverviewSectionTable.module.scss';

interface MetadataSectionContentProps {
  section: SuccessfulOverviewSection<'metadata'>;
}

type MetadataField = SuccessfulOverviewSection<'metadata'>['rows'][number];

/**
 * Renders one form-grouped metadata slice using the existing study metadata table pattern.
 */
const MetadataSectionContent: FC<MetadataSectionContentProps> = ({ section }) => {
  const columns: Array<TanStackColumnDef<MetadataField>> = [
    {
      id: 'title',
      header: 'Name',
      accessorKey: 'title',
    },
    {
      id: 'value',
      header: 'Value',
      accessorKey: 'value',
      cell: ({
        row: {
          original: { field_type: fieldType, value },
        },
      }) => renderMetadataValue({ value, field_type: fieldType }),
    },
  ];

  return (
    <div data-test-component="MetadataSectionContent" data-test-element="container">
      <Table data={section.rows} columns={columns} maxHeightClassName={overviewTableStyles.maxHeight} />
    </div>
  );
};

export default MetadataSectionContent;
